import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FornecedorEstruturaItem } from '../models/fornecedor-estrutura-item';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class FornecedorEstruturaItemService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(forn: FornecedorEstruturaItem) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstruturaItem/Salvar', forn);
  }

  alterarStatus(id, ativo) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstruturaItem/AlterarStatus', undefined, {
      params: new HttpParams().set('id', id).set('ativo', ativo)
    });
  }

  alterarStatusTodos(ativo, idFornecedor, telhado, orientacao) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstruturaItem/AlterarStatusTodos', undefined, {
      params: new HttpParams().set('ativo', ativo).set('idFornecedor', idFornecedor).set('telhado', telhado).set('orientacao', orientacao)
    });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FornecedorEstruturaItem/Excluir', {
      params: new HttpParams().set('id', id),
    });
  }

  consultarPorId(id) {
    let parametros = new HttpParams().set('id', id);

    return this.http.get<any>(globals.apiUrl + '/api/FornecedorEstruturaItem/Buscar', {
      params: parametros,
    });
  }

  consultarItensFornecedor(
    idFornecedor,
    idProduto,
    telhado,
    orientacao,
  ) {
    let parametros = new HttpParams();

    if(idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if(idProduto !== undefined) {
      parametros = parametros.set('idProduto', idProduto);
    }

    if(telhado !== undefined) {
      parametros = parametros.set('telhado', telhado);
    }

    if(orientacao !== undefined) {
      parametros = parametros.set('orientacao', orientacao);
    }

    return this.http.get<FornecedorEstruturaItem[]>(globals.apiUrl + '/api/FornecedorEstruturaItem/Lista', {
      params: parametros
    });
  }

  consultarComPaginacao(
    descri,
    idFornecedor,
    idProduto,
    telhado,
    orientacao,
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '');

    if(idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    if(idProduto !== undefined) {
      parametros = parametros.set('idProduto', idProduto);
    }

    if(telhado !== undefined) {
      parametros = parametros.set('telhado', telhado);
    }

    if(orientacao !== undefined) {
      parametros = parametros.set('orientacao', orientacao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/FornecedorEstruturaItem/ListaPag', {
      params: parametros,
    });
  }
}
